import { useSelector } from "react-redux";

export const useContactFormOptions = () => useSelector((state) => state.contactsReducer.formOptions);
export const useContactPerson = () => useSelector((state) => state.contactsReducer.person);
export const useAvatarLoading = () => useSelector((state) => state.contactsReducer.avatarLoading);
export const useOriginalContactPerson = () => useSelector((state) => state.contactsReducer.originalPerson);
export const useShowPhoneContext = () => useSelector((state) => state.contactsReducer.showPhoneContext);
export const useRoutingNumberModal = () => useSelector((state) => state.contactsReducer.routingNumberModal);
export const useSocialMediaErrors = () => useSelector((state) => state.contactsReducer.socialMediaErrors);
export const useHasSocialMediaErrors = () =>
  useSelector((state) => Object.keys(state.contactsReducer.socialMediaErrors).length > 0);
